var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSequenceWidget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m538.25 814.25h415.75v72.25h-415.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.25 567h415.75v72.25h-415.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m538.25 314h415.75v72.25h-415.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m414.25 311.75v576.5h-40.25l-128-129.75v-27.5h96.75v-419.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSequenceWidget);
export default __webpack_public_path__ + "static/media/sequence-widget.faf0cfb8b38519c6618f82497c35de7f.svg";
export { ForwardRef as ReactComponent };